import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import DasboardNavbar from '../dashboard/DashboardNavbar';
import FeaturesSidebar from './feature/FeaturesSidebar';
import FeaturePage from '../../pages/connect/FeaturePage';
import useMounted from '../../hooks/useMounted';
import { featuresApi } from '../../api/features';
import { projectsApi } from '../../api/projects';
import { Outlet } from 'react-router-dom';



const FeatureLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%'
}));

const FeatureLayoutWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: '64px',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '280px'
  }
}));

const FeatureLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const FeatureLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch'
});

const FeatureLayout = (props) => {
  const mounted = useMounted();
  const params = useParams();
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);

  const [features, setFeatures] = useState(null);
  const [projectName, setProjectName] = useState('');

  // layout page cannot read paht parameters with  useParams
  // we use parent page to keep features fo we can refresh all child pages
  const getFeatures = useCallback(async () => {
    try {
      let projectId = 'NONE';
      const urlX = window.location.href;
      // /features/project/4cca3739-0644-4928-a7c9-2fec268e1cb9/ or  /features/project/4cca3739-0644-4928-a7c9-2fec268e1cb9/feature/e5c1ee7c-2539-40ff-b2c9-ea797b6b2ac8
      if(urlX.includes('/feature/')) {
        projectId = urlX.split('features/project/')[1].split('/feature')[0];
      } else {
        projectId = urlX.split('features/project/')[1];
      }
      const data = await featuresApi.getFeaturesMenu(projectId);
      setFeatures(data);

      const project = await projectsApi.getProject(projectId);
 
      setProjectName(project.name);

    } catch (err) {
      console.error(err);
    }
  }, [mounted]);

  useEffect(() => {
    getFeatures();
  }, [getFeatures]);


  const handleFeatureContent = () => {
    getFeatures();
  };


  return (
    <FeatureLayoutRoot>
      <DasboardNavbar onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)} />
      <FeaturesSidebar featuresMenu={features}
        projectName={projectName}
        onMobileClose={() => setIsSidebarMobileOpen(false)}
        openMobile={isSidebarMobileOpen}
      />
      <FeatureLayoutWrapper>
        <FeatureLayoutContainer>
          <FeatureLayoutContent>
            <Outlet/>
          </FeatureLayoutContent>
        </FeatureLayoutContainer>
      </FeatureLayoutWrapper>
    </FeatureLayoutRoot>
  );
};

export default FeatureLayout;
